import { ChatSession, LoginStatus } from '@klant/conversational-connector/klant-conversational-connector.model';

import { Injectable } from '@angular/core';

import { AccessToken } from '@ap/interface-apic-conversational-chat';

/**
 * @module KlantConversationalModule
 * @ngdoc mapper-service
 * @name ChatSessionMapper
 */
@Injectable({ providedIn: 'root' })
export class ChatSessionMapper {
    public static mapAccessTokenToChatSession(accessToken: AccessToken): ChatSession {
        return {
            token: accessToken.access_token,
            loginStatus: LoginStatus.LOGGED_IN
        };
    }
}
